// ABOUTME: The focused item of a carousel: opens on the stored reading, wraps at both ends, and knows if the child browsed.
// ABOUTME: Until the child moves, the position follows the stored code, so content that loads late still opens on it.

import { useState } from 'react';

export interface CarouselIndex<T> {
  focused: T | undefined;
  index: number;
  count: number;
  prev: () => void;
  next: () => void;
  browsed: boolean;
}

export function useCarouselIndex<T extends { code: string }>(items: T[], storedCode: string | undefined): CarouselIndex<T> {
  const count = items.length;
  const storedIndex = storedCode ? items.findIndex(item => item.code === storedCode) : -1;
  const resumeIndex = storedIndex >= 0 ? storedIndex : 0;

  // Null until the child moves; after that the child's position wins over the stored one.
  const [picked, setPicked] = useState<number | null>(null);
  const index = count ? (picked ?? resumeIndex) % count : 0;

  const move = (step: number) => {
    if (!count) return;
    setPicked((index + step + count) % count);
  };

  return {
    focused: items[index],
    index,
    count,
    prev: () => move(-1),
    next: () => move(1),
    browsed: picked !== null,
  };
}
